<script lang="ts">
	import { onDestroy, onMount } from 'svelte';

	export let videos: { src: string; description: string }[] = [];
	let clazz: string = '';
	export { clazz as class };

	/** The delay in milliseconds before transitioning to the next slide. */
	export let delay: number = 5000;

	export let transitionDuration: number = 1500;

	let activeIndex = 0;
	let htmlVideoEls: HTMLVideoElement[] = [];

	let intervalIndex: NodeJS.Timeout | number;
	let state: 'paused' | 'running' | 'destroyed' = 'paused';

	function startTimer() {
		// console.log('startTimer');
		if (state !== 'paused') return;
		intervalIndex = setInterval(goNext, delay);
		state = 'running';
	}

	// Pause the one that is currently playing at the end of the transition
	// to the next video
	function pauseCurrent() {
		const former = activeIndex;
		if (htmlVideoEls[activeIndex]) {
			setTimeout(() => state !== 'destroyed' && htmlVideoEls[former].pause(), transitionDuration);
		}
	}

	function playNumber(i: number) {
		if (state !== 'destroyed' && htmlVideoEls[i]) {
			htmlVideoEls[i].play();
		}
	}

	function goNumber(i: number) {
		if (state !== 'destroyed') {
			pauseCurrent();
			playNumber(i);
			activeIndex = i;
		}
	}

	function goNext() {
		if (state !== 'destroyed') {
			const nextI = (activeIndex + 1) % videos.length;
			goNumber(nextI);
		}
	}

	function goPrev() {
		if (state !== 'destroyed') {
			// console.log('goPrev');
			const newIndex = activeIndex - 1;
			goNumber(newIndex < 0 ? videos.length - 1 : newIndex);
		}
	}

	function stopTimer() {
		if (state !== 'running') return;
		clearInterval(intervalIndex as any);
		state = 'paused';
	}

	onMount(startTimer);
	onDestroy(() => {
		stopTimer();
		state = 'destroyed';
	});
</script>

<div style="overflow: hidden; width: 100%;" class={clazz || ''} on:mouseleave={startTimer}>
	<!-- The carousel strip -->
	<ul
		style="transform: translateX({-activeIndex * 110}%); transition: {transitionDuration /
			1000}s all ease-in-out; display: flex;"
	>
		{#each videos as { src, description }, i}
			<li style="width: 100%; min-width: 100%; display: block; margin-right: 10%;">
				<figure>
					<!-- svelte-ignore a11y-media-has-caption -->
					<video
						{src}
						autoplay={i === 0}
						loop
						muted
						playsinline
						preload="auto"
						bind:this={htmlVideoEls[i]}
						class="w-full"
					/>
					<figcaption
						style="width: 100%; min-width: 100%; display: block;"
						class="text-center mt-6 text-gray-light text-xl"
					>
						{description}
					</figcaption>
				</figure>
			</li>
		{/each}
	</ul>

	<div class="text-center text-orange text-xl">
		<button
			on:click={() => {
				stopTimer();
				goPrev();
			}}
			style="transform: translateY(8px);"
		>
			<img src="/teach/t-landing/icon-slider-arrow-orange-left.svg" alt="Previous figure" />
		</button>
		{#each videos as video, i}
			<button
				on:click={() => {
					goNumber(i);
					stopTimer();
				}}
				class="bg-orange mx-2 carousel-circle-button {activeIndex === i ? 'active' : ''}"
			>
				<span class="sr-only">Figure {i}</span>
			</button>
		{/each}
		<button
			on:click={() => {
				stopTimer();
				goNext();
			}}
			style="transform: translateY(8px);"
		>
			<img src="/teach/t-landing/icon-slider-arrow-orange-right.svg" alt="Next figure" />
		</button>
	</div>
</div>

<style lang="postcss">
	.carousel-circle-button {
		border-radius: 10px;
		width: 10px;
		height: 10px;
		transition: 1s all ease-in;
	}

	.carousel-circle-button.active {
		border-radius: 16px;
		width: 16px;
		height: 16px;
	}
</style>
